import React, { Component } from 'react'

export default class IconInfoBlue extends Component {
    render() {
        return (
            <svg
                className={this.props.className}
                xmlns="http://www.w3.org/2000/svg"
                width={this.props.width || 24}
                height={this.props.height || 28}
                fill="none"
                viewBox="0 0 24 28"
                >
                <path
                    fill="#26A"
                    d="M12.81 16.931c-.078 0-.147-.02-.173-.053-.021-.027-.032-.073-.032-.14 0-.106.005-.266.037-.405.127-.598.259-1.19.39-1.782.106-.458.127-.83.085-1.19-.074-.545-.517-.983-1.034-1.023-.464-.033-.87.153-1.266.332l-.142.067a.348.348 0 00-.185.232 3.395 3.395 0 00-.063.32l-.095.478.306-.08c.058-.013.11-.033.163-.046.1-.034.2-.06.306-.067.111-.006.196.007.232.053.037.047.032.153.027.206a7.707 7.707 0 01-.132.825c-.042.219-.095.438-.148.651-.11.452-.226.924-.253 1.423-.021.478.121.857.422 1.13.232.206.49.305.791.305.127 0 .259-.02.396-.053.226-.053.438-.153.649-.246.079-.033.158-.073.237-.106a.374.374 0 00.19-.24 5.22 5.22 0 00.058-.279l.09-.445-.48.073c-.127.04-.248.06-.375.06zM12.414 11.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
                ></path>
                <path
                    fill="#26A"
                    fillRule="evenodd"
                    d="M11.992 4C17.52 3.992 22.008 8.474 22 14.004A9.992 9.992 0 0112.008 24C6.488 24.016 1.992 19.526 2 13.996A9.997 9.997 0 0111.992 4zm.016 1.991c-4.392-.008-8.002 3.587-8.018 7.997-.016 4.393 3.57 7.997 7.994 8.029 4.383.032 8.026-3.604 8.026-8.013 0-4.401-3.594-8.005-8.002-8.013z"
                    clipRule="evenodd"
                ></path>
            </svg>
        )
    }
}
